const LOCAL_API_URL = {
  MYCAR_COMMON_COMMENTS_API: 'https://dev.apis.naver.com/commentBox/cbox12',
  AB_TEST: 'https://api.abt.naver.com'
};
const LOCAL_WEB_URL = {
  ABOUT: 'https://alpha-m.pay.naver.com/mobile/about',
  AB_TEST_LOG: 'https://co.naver.com/a',
  ADS_AND_POINTS: 'http://alpha-npayad.naver.com',
  APP_GATEWAY: 'https://app-gateway-dev.pay.naver.com',
  CAMPAIGN: 'https://alpha-m-campaign.naver.com',
  CARD: 'https://alpha.dbill.naver.com',
  CARD_SEARCH: 'https://m-test-card-search.naver.com',
  CART: 'http://alpha-m.shopping.naver.com/cart',
  CPM_POINT_GAMBLE: 'https://alpha-m-campaign.naver.com/npay/gorandomp',
  EASY_APPLY: 'https://alpha-easy-apply.pay.naver.com',
  EVENT: 'https://alpha-event2.pay.naver.com',
  FRIENDS: 'https://dev.friends.naver.com',
  GFD: 'https://internal-ndev.pay.naver.com/ad/seg',
  GIFT: 'https://test-mgift.pay.naver.com',
  HANABANK: 'https://stg11-m.hanabank.com:18680',
  HELP: 'https://alpha-m.help.naver.com',
  INFLOW: 'https://alpha-inflow.pay.naver.com',
  INSURANCE: 'https://dev-insurance.pay.naver.com',
  INVOICE: 'https://invoice.naver.com',
  KEYPAD: 'https://nid.naver.com',
  LAND: 'https://test-neo.land.naver.com',
  L_PAY: 'https://dev-nsp.pay.naver.com',
  MYCAR_COMMON_COMMENTS_DOMAIN: 'https://alpha-static-cbox.naver.net',
  MYMONEY: 'https://dev-mymoney.pay.naver.com',
  MYMONEY_EVENT: 'https://alpha-m-campaign.naver.com',
  MY_CAR: 'https://dev-mycar.naver.com',
  MY_GIFT: 'https://dev-gift.naver.com/mygift/r',
  MY_MONEY: 'https://dev-mymoney.pay.naver.com',
  M_SHOPPING: 'https://alpha-m.shopping.naver.com',
  M_SHOPPING_HOME: 'https://test-m.shopping.naver.com/home/m/index.nhn',
  M_SHOPPING_MY_BRANCH: 'https://alpha-m.shopping.naver.com/market/my/order',
  M_SHOPPING_SUBSCRIPTIONS: 'https://dev-m.shopping.naver.com/my/subscriptions',
  PC_SHOPPING_SUBSCRIPTIONS: 'https://dev.shopping.naver.com/my/subscriptions',
  M_HAPPYBEAN_SUBSCRIPTION: 'https://m.happybean.naver.com/my/timeline#type=funding',
  PC_HAPPYBEAN_SUBSCRIPTION: 'https://happybean.naver.com/my/timeline#type=funding',
  NAVER: 'https://t01.m.naver.com',
  NEW_PAY: 'https://new-dev4-m.pay.naver.com',
  NID: 'https://nid.naver.com',
  ORDER: 'https://alpha-m.pay.naver.com',
  PAY: 'https://alpha-m.pay.naver.com',
  PAY_APP: 'https://app.pay.naver.com',
  PAY_SEND: 'https://alpha-m.pay.naver.com/send/m',
  PC_CAMPAIGN: 'https://alpha-campaign.naver.com',
  PC_ORDER: 'https://alpha-order.pay.naver.com',
  PC_PAY: 'https://alpha-pay.naver.com',
  PLACE: 'https://qa-m.place.naver.com',
  POINT_GIFT: 'https://dev-m.pay.naver.com/mobile/point/pointgift/front/form',
  REWARD_PARTNERSHIP: 'http://alpha-npayad.naver.com',
  SDK: 'https://test-img.tveta.naver.net/libs/ssp/ssp.web.sdk.js',
  SHOPPING: 'https://alpha.shopping.naver.com',
  STANDBY: 'https://dev-waiting.ssl.naver.com',
  STATIC: 'http://alpha-img.pay.naver.net',
  TALKTALK: 'https://dev.talk.naver.com',
  TALK_TO: 'https://dev.talk.naver.com/to',
  TRACE: 'https://tr-qa.pay.naver.com',
  FE_CDN_ORIGIN: 'https://stage-financial-pstatic.fe.naver.com',
  AD_PLATFORM: 'https://ica-qa.pay.naver.com'
};

export { LOCAL_API_URL, LOCAL_WEB_URL };
